import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SEOService {

  constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc) { }

  createLinkForCanonicalURL(href: string) {
    let links = this.doc.getElementsByTagName("link");
    links[1].setAttribute('href', href);
  }



  updateTitle(title: string) {
    this.title.setTitle(title);
    this.meta.updateTag({ name: 'og:title', content: title })
  }

  updateOgUrl(url: string) {
    this.meta.updateTag({ name: 'og:url', content: url })
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc })
    this.meta.updateTag({ name: "og:description", content: desc })
  }

  addTags(metaTags: any) {
    if (metaTags) {
      metaTags.forEach(element => {
        if (element.name === 'og:url') {
          this.createLinkForCanonicalURL(element.content)
        }
        this.meta.updateTag({ name: element.name, content: element.content, property: element.property })
      });
    }
  }
}